import * as types from "../Actions/Types";

export interface INotificationWorkflowReducerState {
    notificationWorkflowUrl: string;
}

const defaultState: INotificationWorkflowReducerState = {
    notificationWorkflowUrl: "",
};

export const notificationWorkflowReducer = (
    state: INotificationWorkflowReducerState = defaultState,
    action,
) => {
    switch (action.type) {
        case types.SET_NOTIFICATION_WORKFLOW_URL:
            return {
                ...state,
                notificationWorkflowUrl: action.data,
            };

        default:
            return state;
    }
};
